const rawApiBase = ((import.meta.env.VITE_API_BASE as string | undefined) ?? '').trim();
export const API_BASE = rawApiBase.replace(/\/+$/, '');

if (!API_BASE) {
  console.warn('[apiClient] Missing VITE_API_BASE; set it in your environment configuration.');
}

const BASE = API_BASE;

let authToken: string | null = null;

export function setAuthToken(token: string | null) {
  authToken = token;
}

async function request(path: string, options: RequestInit = {}) {
  if (!BASE) {
    throw new Error('API base URL is not configured (VITE_API_BASE is missing).');
  }

  const isFormData = options.body instanceof FormData;

  const headers: Record<string, string> = {
    ...(options.headers as Record<string, string> || {}),
  };

  if (!isFormData) headers['Content-Type'] = 'application/json';
  if (authToken) headers['Authorization'] = `Bearer ${authToken}`;

  const res = await fetch(`${BASE}${path.startsWith('/') ? '' : '/'}${path}`, {
    ...options,
    headers,
  });

  const text = await res.text();
  let data: unknown;

  try {
    data = text ? JSON.parse(text) : undefined;
  } catch {
    data = text;
  }

  if (!res.ok) {
    const detail =
      typeof data === 'object' && data !== null && 'detail' in data
        ? String((data as { detail?: string }).detail)
        : typeof data === 'string'
          ? data
          : res.statusText;
    throw new Error(detail);
  }

  return data;
}

export default { request, setAuthToken };
